











































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { InspectButtonValue } from "@/model/InspectButtonValue";
import InputNumber from "@/components/common/input/InputNumber.vue";
import EstimateInspectionCostComponent from "@/components/EstimateInspectionCostComponent.vue";
import QuickCouponComponent from "@/components/QuickCouponComponent.vue";
import QuickOptionComponent from "@/components/QuickOptionComponent.vue";
import EstimateListComponent from "@/components/EstimateListComponent.vue";
import EstimatePreview from "@/components/EstimatePreview.vue";
import Number from "@/shared/filters/Number.ts";
import InputString from "@/components/common/input/InputString.vue";
import { INSPECT_TYPE } from "@/model/InspectType";
import requestService from "@/service/requestService";
import loadingService from "@/service/loadingService";
import { NAVIGATION_STATUS } from "@/model/NavigationStatus";
/** 2021-08-18 sh #7350 if change estimate at User screen, re-get jizen mitsumori. [START] */
import { MESSAGE } from "@/model/Message";
/** 2021-08-18 sh #7350 if change estimate at User screen, re-get jizen mitsumori. [END] */
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
/** 2021-09-07 sh #7391 implements socket for option and coupon. [START] */
import { UserService } from "@/service/UserService";
import { SocketControllers } from "@/service/SocketControllers";
/** 2021-09-07 sh #7391 implements socket for option and coupon. [END] */
import vuedraggable from "vuedraggable";
export interface SideTab {
  status: boolean;
}

@Component({
  components: {
    InputNumber,
    InputString,
    EstimateInspectionCostComponent,
    QuickCouponComponent,
    QuickOptionComponent,
    EstimateListComponent,
    EstimatePreview
    , ConfirmDialog
    , draggable: vuedraggable
  },
  filters: { Number }
})
export default class estimateDetail extends Vue {

  $refs!: {
    estimateInspectionCostComponent: EstimateInspectionCostComponent;
    quickCouponComponent: QuickCouponComponent;
    quickOptionComponent: QuickOptionComponent;
    estimateListComponent: EstimateListComponent;
    dialog: ConfirmDialog;
    confirmDialogOnlyClose: ConfirmDialog;
  };

  listPrefectures: any = {};

  isUserMode = false;
  seibiList: any = [];
  companyInfo: any = {};

  inspectType: number = INSPECT_TYPE.RECOMMEND;

  showDialogInspectionCost: boolean = false;
  showDialogCoupon: boolean = false;
  showDialogEstimate: boolean = false;
  showDialogPreview: boolean = false;
  showDialogOption: boolean = false;

  loading: boolean = false;
  loadingText: string = MESSAGE.Loading;
  data: any = {};
  estData: any = {};
  estIssueAt: string = "";

  public reqService: requestService = new requestService();
  public sktControll: SocketControllers = new SocketControllers();
  loadingService: loadingService = new loadingService();

  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;

  /** 2021-08-18 sh #7350 if change estimate at User screen, re-get jizen mitsumori. [START] */
  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: string;
  @Getter("yoyakuNo", { namespace: "ReservationDetail" })
  yoyakuNo: string;
  /** 2021-08-18 sh #7350 if change estimate at User screen, re-get jizen mitsumori. [END] */

  /** 2023-10-19 invoice [START] */
  @Getter("isExcludingTax", { namespace: "FunctionSetting" })
  isExcludingTax: any;
  @Getter("taxLabel", { namespace: "FunctionSetting" })
  taxLabel: string;
  /** 2023-10-19 invoice [END] */
  // 2022-01-31 morisako kobac-free add [START]
  freeOfChargeNm: string = '無償';
  freeOfChargeNm2: string = '対応';
  // 2022-01-31 morisako kobac-free add [END]

  /** 2022-03-16 sh #7780(BQR807-17) add check ryoukin-rank. [START] */
  @Getter("currentState", { namespace: "ReservationDetail" })
  reservationDetail: any;

  confirmDialogMsg: string = '';
  /** 2022-03-16 sh #7780(BQR807-17) add check ryoukin-rank. [END] */
  /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
  timeId: any = null;
  /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */

  created() {
    this.isUserMode = this.$route.meta === "user";
    this.getCompanyInfo();
    this.getJizenMitsumoriPreview();
    this.$nextTick(() => {
    this.getJizenResult();
    });
    this.getJizenInspectionSeibi();

    /** 2021-08-18 sh #7350 if change estimate at User screen, re-get jizen mitsumori. [START] */
    this.sktControll.connectSocket(this.onConnect);
    /** 2021-08-18 sh #7350 if change estimate at User screen, re-get jizen mitsumori. [END] */
    // 2022-01-31 morisako kobac-free add [START]
    this.getFreeOfChargeNm();
    // 2022-01-31 morisako kobac-free add [END]
  }

  mounted() {
    /** 2022-03-16 sh #7780(BQR807-17) add check ryoukin-rank. [START] */
    /** 料金ランクが設定済みかチェックする。NGの場合、税金情報のダイアログを開いてさらに小窓を開く。 */
    if (this.isValidRyoukinRank()) {
      this.getJizenMitsumoriPreview();
    } else {
      this.showDialogInspectionCost = true;
      setTimeout(() => {
        this.$refs.estimateInspectionCostComponent.showTaxDialog();
      }, 500);
    }
    /** 2022-03-16 sh #7780(BQR807-17) add check ryoukin-rank. [END] */
  }

  getJizenMitsumoriPreview() {
    this.reqService.getJizenMitsumoriPreview(this.uketsukeExtendsId).then(
      (res: any) => {
        let shakenHiyouItem = [];
        if (res.shakenHiyouItems) {
          shakenHiyouItem = res.shakenHiyouItems.filter((item: any, index: number) => {
            return index === res.shakenHiyouItems.findIndex((obj: any) => {
              return item.shohiyouCd == obj.shohiyouCd && item.shohiyouNm == obj.shohiyouNm;
            }) && item.shohiyouNm != '';
          });
        }
        res.shakenHiyouItems = shakenHiyouItem;
        /** 2021-08-23 sh #7361 it updates kensaHiyou after update kensaHiyou. [START] */
        // this.data = res;
        this.$set(this, "data", []);
        this.$set(this, "data", res);
        if (this.$refs.estimateInspectionCostComponent
        && typeof this.$refs.estimateInspectionCostComponent.onUpdateShohiyou === 'function' ) {
          this.$refs.estimateInspectionCostComponent.onUpdateShohiyou();
        }
        /** 2021-08-23 sh #7361 it updates kensaHiyou after update kensaHiyou. [END] */

        /** 2021-09-07 sh #7391 implements socket for option and coupon. [START] */
        this.onUpdateCoupon();
        this.onUpdateOption();
        /** 2021-09-07 sh #7391 implements socket for option and coupon. [END] */
      },
      (err: any) => {
      }
    );
  }

  getJizenResult() {
    /** 2022-11-29 sh #8121(BQR982) get free of charge after change shaken-shurui. (add loading.) [START] */
    this.$set(this, "loading", true);
    /** 2022-11-29 sh #8121(BQR982) get free of charge after change shaken-shurui. (add loading.) [END] */
    this.reqService.getJizenResult(this.uketsukeExtendsId).then(
      (res: any) => {
        this.$set(this, "estIssueAt", res.estIssueAt);
        /** 2021-08-23 sh #7361 it updates kensaHiyou after update kensaHiyou. [START] */
        // this.estData = res.jizenResult;
         this.$set(this, "estData", []);
         this.$set(this, "estData", res.jizenResult);
        /** 2021-08-23 sh #7361 it updates kensaHiyou after update kensaHiyou. [END] */

        /** 2021-11-26 sh #7574 set to currentIndex at estimateList. [START] */
        /** する・しない・後日を押した場合、データを取得しなおしているので、子画面が開いていたら、スクロールさせる */
        if (this.showDialogEstimate) {
          this.$refs.estimateListComponent.scrollToCurrentIndex();
        }
        /** 2021-11-26 sh #7574 set to currentIndex at estimateList. [END] */
        if (this.estData && this.estData.length > 0) {
          if (this.estData[0].osusume) {
            this.inspectType = INSPECT_TYPE.RECOMMEND;
          } else {
            this.inspectType = INSPECT_TYPE.LEGAL56;
          }
          this.setSeibiData();
          /** 2021-08-20 sh #7356  send message to customer-screen. [START] */
          if (this.$refs.estimateListComponent && typeof this.$refs.estimateListComponent.updateCurrentData === 'function') {
            this.$refs.estimateListComponent.updateCurrentData();
          }
          /** 2021-08-20 sh #7356  send message to customer-screen. [END] */
        }
        /** 2022-11-29 sh #8121(BQR982) get free of charge after change shaken-shurui. (add loading.) [START] */
        this.$set(this, "loading", false);
        /** 2022-11-29 sh #8121(BQR982) get free of charge after change shaken-shurui. (add loading.) [END] */
      },
      (err: any) => {
        /** 2022-11-29 sh #8121(BQR982) get free of charge after change shaken-shurui. (add loading.) [START] */
        this.$set(this, "loading", false);
        /** 2022-11-29 sh #8121(BQR982) get free of charge after change shaken-shurui. (add loading.) [END] */
      }
    );
  }

  getJizenInspectionSeibi() {
    this.reqService.getJizenInspectionSeibi(this.uketsukeExtendsId).then(
      (res: any) => {
        /** 2021-08-23 sh #7361 it updates kensaHiyou after update kensaHiyou. [START] */
        // this.seibiList = res;
        this.$set(this, "seibiList", []);
        this.$set(this, "seibiList", res);
        /** 2021-08-23 sh #7361 it updates kensaHiyou after update kensaHiyou. [END] */
      },
      (err: any) => {
        /** 2022-10-19 sh #8066(BQR974) Choose from multiple parts. [START] */
        if (err && err.hasOwnProperty("status") && err.status == 204) {
          this.$set(this, "seibiList", []);
        }
        /** 2022-10-19 sh #8066(BQR974) Choose from multiple parts. [END] */
      }
    );
  }

  sumItem(item: any) {
    /** 2023-10-19 invoice [START] */
    return this.isExcludingTax? (item.buhinEditTotalZn || 0) + ( item.kouchinEditZn || 0) : (item.buhinEditTotalZk || 0) + ( item.kouchinEditZk || 0);
    /** 2023-10-19 invoice [END] */
  }

  isTriangle(item: any) {
    return item.inspectResult == InspectButtonValue.TRIANGLE;
  }

  isCross(item: any) {
    return item.inspectResult == InspectButtonValue.CROSS;
  }

  get calcTotal2() {
    let total = 0;
    this.seibiList.forEach((elm: any) => {
        let itemTotal = this.sumItem(elm);
        total += itemTotal;
    });
    return total;
  }

  onShowDialogInspectionCost() {
    this.showDialogInspectionCost = true;
  }

  onShowDialogCoupon() {
    this.showDialogCoupon = true;
  }

  onShowDialogEstimate() {
    this.showDialogEstimate = true;
  }

  setSeibiData() {
    this.estData.forEach((element: any) => {
      if (element.osusume) {
        if (element.recommend && element.recommend.length > 0) {
          element.recommend.forEach((sub: any) => {
            if (sub.subItems && sub.subItems.length > 0) {
              sub.subItems.forEach((item: any) => {
                if (item.buhinEditTotalZn == null) {
                  item.buhinEditTotalZn = item.buhinZn;
                }
                if (item.buhinEditTotalZk == null) {
                  item.buhinEditTotalZk = item.buhinZk;
                }
                if (item.kouchinEditZn == null) {
                  item.kouchinEditZn = item.kouchinZn;
                }
                if (item.kouchinEditZk == null) {
                  item.kouchinEditZk = item.kouchinZk;
                }
                item.totalZk = item.buhinEditTotalZk + item.kouchinEditZk;
                item.totalZn = item.buhinEditTotalZn + item.kouchinEditZn;
              });
            }
          });
        }
      } else {
        if (element.subItems && element.subItems.length > 0) {
          element.subItems.forEach((sub: any) => {
            if (sub.subItems && sub.subItems.length > 0) {
              sub.subItems.forEach((item: any) => {
                if (item.buhinEditTotalZn == null) {
                  item.buhinEditTotalZn = item.buhinZn;
                }
                if (item.buhinEditTotalZk == null) {
                  item.buhinEditTotalZk = item.buhinZk;
                }
                if (item.kouchinEditZn == null) {
                  item.kouchinEditZn = item.kouchinZn;
                }
                if (item.kouchinEditZk == null) {
                  item.kouchinEditZk = item.kouchinZk;
                }
                item.totalZk = item.buhinEditTotalZk + item.kouchinEditZk;
                item.totalZn = item.buhinEditTotalZn + item.kouchinEditZn;
              });
            }
          });
        }
      }
    });
  }

  onCloseDialogInspectionCost() {
    this.$refs.estimateInspectionCostComponent.onConfirm();
    this.getJizenMitsumoriPreview();
    this.showDialogInspectionCost = false;
  }

  onCloseDialogCoupon() {
    this.$refs.quickCouponComponent.onConfirm(1);
    /** 2024-10-30 クーポンの保存と読込の順序が入替わらぬよう処理分解 [START] */
    //this.getJizenMitsumoriPreview();
    //this.showDialogCoupon = false;
  }

  onCloseDialogCouponNext() {
    this.getJizenMitsumoriPreview();
    this.showDialogCoupon = false;
    /** 2024-10-30 クーポンの保存と読込の順序が入替わらぬよう処理分解 [END] */
  }

  onShowDialogOption() {
    this.showDialogOption = true;
  }

  onCloseDialogOption() {
    this.$refs.quickOptionComponent.onConfirm(1);
    /** 2024-10-30 オプションの保存と読込の順序が入替わらぬよう処理分解 [START] */
    //this.getJizenMitsumoriPreview();
    //this.showDialogOption = false;
  }

  onCloseDialogOptionNext() {
    this.getJizenMitsumoriPreview();
    this.showDialogOption = false;
    /** 2024-10-30 オプションの保存と読込の順序が入替わらぬよう処理分解 [END] */
  }

  onCloseDialogEstimate() {
    this.getJizenInspectionSeibi();
    this.getJizenMitsumoriPreview();
    this.showDialogEstimate = false;
  }

  onShowPrintJizenMitsumori() {
    this.showDialogPreview = true;
  }

  onPrintJizenMitsumori() {
    /** 2022-03-16 sh #7780(BQR807-17) add check ryoukin-rank. [START] */
    if (!this.isValidRyoukinRank()) {
      /** 料金ランクが未設定の場合、印刷させない */
      this.confirmDialogMsg = MESSAGE.InvalidRyoukinRank;
      this.$refs.confirmDialogOnlyClose.onOpen();
      return ;
    }
    /** 2022-03-16 sh #7780(BQR807-17) add check ryoukin-rank. [END] */
    this.loadingService.show();
    this.reqService.getSknEstimate(this.uketsukeExtendsId).then((blob: any) => {
      this.loadingService.hide();
      let link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = '概算車検見積書.pdf'; // 2021-11-10 sh #7536 change name from 車検見積結果 to 概算車検見積書
      link.click();
    /** 2022-03-16 sh #7780(BQR807-17) add check ryoukin-rank. [START] */
    }, (err: any) => {
      /** ローディングを止める */
      this.loadingService.hide();
      this.$notify.error({
        title: "エラー",
        message: MESSAGE.SystemError
      });
    /** 2022-03-16 sh #7780(BQR807-17) add check ryoukin-rank. [END] */
    });
  }

  onCloseDialogPreview() {
    this.showDialogPreview = false;
  }

  getCompanyInfo() {
    this.reqService.getPrefectures().then(list => {
      this.listPrefectures = list;

      this.reqService.getCompanyInfo().then((res)=> {
        if(res) {
          this.companyInfo = res;

          const pref = this.listPrefectures.filter( (e: any) => e.prefCd == this.companyInfo.prefCd );
          if (pref && pref.length > 0) {
            this.companyInfo.prefNm = pref[0].prefNm;
          }
        }
      }, (err: any) => {
        this.companyInfo = {
          zip1: null,
          zip2: null,
          prefCd: null,
          prefNm: null,
          addr1: null,
          addr2: null,
          shatenNm: null,
          kyotenNm: null,
          tel1: null,
          tel2: null,
          tel3: null,
          lineQr: null
        };
      });
    });
  }

  onRegister() {
    this.$emit("onregister", { pageName: this.$route.name, status: NAVIGATION_STATUS.REGISTER });
  }

  //モーダルの状況で実行抑制
  execOnPayments(){
    if(!this.showDialogEstimate){
      this.onPayments();
    }
  }

  /** 2021-08-18 sh #7350 if change estimate at User screen, re-get jizen mitsumori. [START] */
  onPayments(){
    /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [START] */
    // this.$notify.info({
    //   title: "Info",
    //   message: MESSAGE.UpdatedJizenEstimate
    // });
    // this.getJizenMitsumoriPreview();
    // this.getJizenResult();
    // this.getJizenInspectionSeibi();
    clearTimeout(this.timeId);
    this.timeId = setTimeout(() => {
      this.$notify.info({
        title: "Info",
        message: MESSAGE.UpdatedJizenEstimate
      });
      this.getJizenMitsumoriPreview();
      this.getJizenResult();
      this.getJizenInspectionSeibi();
    }, 1500);
    /** 2023-03-30 sh #8188(BQR1084) course does not work for recommend. [END] */
  }

  onConnect() {
    if (this.uketsukeCd && this.uketsukeExtendsId) {
      /** やりたいことは、再読込なので、流用する */
      this.sktControll.socketCustomerKensaHiyou(this.onPayments);
      this.sktControll.socketCustomerEditPrice(this.execOnPayments);
      this.sktControll.socketPayments(this.onPayments);
      this.sktControll.socketInspections(this.onPayments); // ポップアップ上で変更があった場合に、再読み込みを行う
      this.sktControll.socketShohiyouCompleted(this.onPayments);
      this.sktControll.socketOption(this.onPayments);
      this.sktControll.socketCoupon(this.onPayments);
      this.sktControll.socketInspectSeibi(this.onPayments);
      this.sktControll.socketShohiyouReload(this.onFreeOfChargeBeforeOnPayments);
    }
  }

  destroyed() {
    this.sktControll.freeSocketResources();
  }
  /** 2021-08-18 sh #7350 if change estimate at User screen, re-get jizen mitsumori. [END] */

  /** 2021-08-23 sh #7361 change shakenTotal from referenct to mutation. [START] */
  get shakenTotal() {
    return this.data.calcTotal;
  }
  /** 2021-08-23 sh #7361 change shakenTotal from referenct to mutation. [END] */
  onSave() {
    this.$refs.dialog.onOpen();
  }
  onSubmit() {
      this.reqService.updateSknWorkProgressStateOnHold(this.uketsukeExtendsId).then(
        (res: any) => {
          this.$router.push({ name: "reservation" });
        },
        (err: any) => {
        }
      );
  }
  /** 2021-09-07 sh #7391 implements socket for option and coupon. [START] */
  onUpdateCoupon() {
    const userService = new UserService();
    userService.getCoupon();
  }
  onUpdateOption() {
    const userService = new UserService();
    userService.getOption();
  }
  /** 2021-09-07 sh #7391 implements socket for option and coupon. [END] */

  /** 2021-10-05 sh #7438 implements tech info amount. [START] */
  get isUseTechInfoAmount() {
    return this.data.isUseTechInfoAmount == 1;
  }
  /** 2021-10-05 sh #7438 implements tech info amount. [END] */

  /** 2021-10-25 sh #7493 change display of spec. [START] */
  onEndDraggable() {
    setTimeout(() => {
      console.log("estimateDetail.onEndDraggable seibiList", this.seibiList);
      /** 今の並び順をdisplayOrderに設定しておく。 */
      const saveData = this.seibiList.map((e: any, index: number) => {
        e.displayOrder = index + 1; // 0番目だと、ISNULLでNULL判定になる感じなので、+1しておく。
        return e;
      });
      const promise = this.saveJizenDisplayOrderPM(this.uketsukeExtendsId, saveData);

      this.$set(this, "loading", true);
      Promise.all([promise]).then((val: any) => {
        this.getJizenMitsumoriPreview();
        this.$set(this, "loading", false);

      }, (err: any) => {
        this.$set(this, "loading", false);

      });
    }, 1000);
  }

  saveJizenDisplayOrderPM(uketsukeExtendsId: any, data: any) {
    const promise = new Promise((resolve, reject) => {
      this.reqService.saveJizenDisplayOrder(uketsukeExtendsId, data).then((res: any) => {
        resolve(res);
      }, (err: any) => {
        reject(err);
      });
    });
    return promise;
  }

  isNotRecommend(item: any) {
    return !(item.sknInspectId == null);
  }
  /** 2021-10-25 sh #7493 change display of spec. [END] */
  // 2022-01-31 morisako kobac-free add [START]
  getFreeOfChargeNm() {
    this.reqService.getMSknFreeOfCharge(this.uketsukeExtendsId)
    .then((res: any) => {
      this.freeOfChargeNm = res.freeOfChargeNm.substr(0, 2);
      this.freeOfChargeNm2 = res.freeOfChargeNm.substr(2, 2);
    });
  }
  // 2022-01-31 morisako kobac-free add [END]
  /** 2022-03-16 sh #7780(BQR807-17) add check ryoukin-rank. [START] */
  isValidRyoukinRank() {
    if (this.reservationDetail.sknUketsukeExtends && !this.reservationDetail.sknUketsukeExtends.ryoukinRankCd) {
      return false;
    }
    return true;
  }
  /** 2022-03-16 sh #7780(BQR807-17) add check ryoukin-rank. [END] */

  /** 2022-11-29 sh #8121(BQR982) get free of charge after change shaken-shurui. [START] */
  onFreeOfChargeBeforeOnPayments() {
    this.$set(this, "loading", true);
    this.reqService.setFreeOfCharge(this.uketsukeExtendsId).then(
      (res: any) => {
        this.$set(this, "loading", false);
        this.getFreeOfChargeNm();
        this.onPayments();
      },
      (err: any) => {
        this.$set(this, "loading", false);
      }
    );
  }
  /** 2022-11-29 sh #8121(BQR982) get free of charge after change shaken-shurui. [END] */

}
